<template>
  <div class="mt-3">
    <SearchBar
      placeholder="Search images..."
      path="/api/v2/reveal-images"
      :useAutocomplete="true"
      :filters="searchFilters"
      @search-results="handleResults" />
    <div class="d-flex align-items-center">
      <b-button size="sm" variant="secondary" class="mb-2 mr-2" @click="cancel">
        <b-icon icon="arrow-left"></b-icon>Cancel</b-button>
      <b-button  v-if="selectedImage" size="sm" variant="success" class="mb-2" @click="handleConfirm">
        <b-icon icon="check"></b-icon>Confirm</b-button>
    </div>
    <div class="scrollable-window">
      <div class="row">
        <div v-if="emptyResults" class="col"><p class="text-center"><em>No images found matching your search query.</em></p></div>
        <div class="col-4" v-for="(image, index) in imageResults"
          :key="`default_image_${index}`">
          <Card :card="image" :selected="selectedImage === image"
            @card-selected="handleCardSelected" @remove-card="handleRemoveCard" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations, mapGetters } from 'vuex';
import Card from './Card.vue';
import SearchBar from '../../components/SearchBar.vue';

export default {
  components: { Card, SearchBar },

  data() {
    return {
      imageResults: [],
      emptyResults: false,
      selectedImage: null,
      searchFilters: [],
    };
  },

  props: {
    position: {
      type: Number,
      required: true,
    },
  },

  mounted() {
    if (this.defaultImages.length === 0) this.fetchImages();
    this.imageResults = this.defaultImages;
    this.searchFilters = [
      {
        title: 'Mine', type: 'checkbox', field: 'user_id', value: this.userId,
      },
    ];
  },

  computed: {
    ...mapState(['userId', 'defaultImages']),
    ...mapGetters([]),
  },

  methods: {
    ...mapMutations(['addRevealImage', 'setDefaultImages']),

    cancel() {
      this.$emit('cancel');
    },

    fetchImages() {
      axios.get('/api/v2/reveal-images').then((response) => {
        this.setDefaultImages(response.data);
        this.imageResults = this.defaultImages;
      });
    },

    handleCardSelected(image) {
      this.selectedImage = image;
    },

    handleConfirm() {
      const { id, title, image } = this.selectedImage;
      const positionImage = {
        reveal_image_id: id, title, image, position: this.position,
      };
      this.addRevealImage(positionImage);
      this.$emit('image-added');
    },

    handleResults(results, showEmptyMsg) {
      this.imageResults = results;
      this.emptyResults = showEmptyMsg;
    },

    handleRemoveCard() {
      this.selectedImage = null;
    },
  },
};
</script>
